import { useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  Box,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { selectVacuumBreaker } from "../../services/vacuum-breaker/VacuumBreakerService";
import { alpha } from "../../theme/tokens";

const VacuumBreakerSelectionPage = () => {
  const [vw, setVw] = useState("");
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  const handleCalculate = async () => {
    const vwNum = parseFloat(vw);
    if (isNaN(vwNum) || vwNum <= 0) {
      setError("Vw deve ser um valor positivo");
      return;
    }
    setLoading(true);
    setError(null);
    setResult(null);
    try {
      const data = await selectVacuumBreaker(vwNum, 0.4);
      setResult(data);
    } catch (err) {
      setError(err.response?.data?.message || "Erro ao calcular");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ display: "flex", justifyContent: "center", mt: 4, px: 2 }}>
      <Card sx={{ width: "100%", maxWidth: 600, borderRadius: 3, boxShadow: 4 }}>
        <CardContent sx={{ p: 4 }}>
          <Typography variant="h5" sx={{ fontWeight: 700, color: "primary.main", mb: 3, textAlign: "center" }}>
            Seleção Vacuum Breaker
          </Typography>

          <TextField
            fullWidth
            label="Vw (m³/h)"
            type="number"
            value={vw}
            onChange={(e) => setVw(e.target.value)}
            sx={{
              mb: 2,
              "& label.Mui-focused": { color: "primary.main" },
              "& .MuiOutlinedInput-root.Mui-focused fieldset": { borderColor: "primary.main" },
            }}
          />

          <Typography variant="body2" sx={{ color: "text.secondary", mb: 2 }}>
            Δp = 0.4 bar (fixo)
          </Typography>

          <Button
            fullWidth
            variant="contained"
            onClick={handleCalculate}
            disabled={loading || !vw}
            sx={{
              backgroundColor: "primary.main",
              color: "white",
              py: 1.2,
              textTransform: "none",
              fontSize: "1rem",
              "&:hover": { backgroundColor: "primary.dark" },
            }}
          >
            {loading ? <CircularProgress size={24} sx={{ color: "white" }} /> : "Calcular"}
          </Button>

          {error && (
            <Typography sx={{ mt: 2, color: "error.dark", textAlign: "center" }}>
              {error}
            </Typography>
          )}

          {result && (
            <Box sx={{ mt: 3 }}>
              <Typography variant="h6" sx={{ fontWeight: 600, color: "primary.main", mb: 2 }}>
                Resultado
              </Typography>
              <TableContainer component={Paper} variant="outlined" sx={{ borderRadius: 2 }}>
                <Table size="small">
                  <TableHead>
                    <TableRow sx={{ bgcolor: alpha.primary30 }}>
                      <TableCell sx={{ fontWeight: 700 }}>Descrição</TableCell>
                      <TableCell sx={{ fontWeight: 700 }}>Valor</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell>Vw (m³/h)</TableCell>
                      <TableCell>{result.vwRequired}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Δp (bar)</TableCell>
                      <TableCell>{result.deltaPBar}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Quantidade DN</TableCell>
                      <TableCell> {result.quantity} x DN {result.dn}</TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell>Capacidade por válvula (m³/h)</TableCell>
                      <TableCell>{result.capacityPerValve?.toFixed(3)}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Capacidade total (m³/h)</TableCell>
                      <TableCell>{result.totalCapacity?.toFixed(3)}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          )}
        </CardContent>
      </Card>
    </Box>
  );
};

export default VacuumBreakerSelectionPage;
